module.exports = __webpack_public_path__ + "img/mc.acbf04f7.svg";